function SearchPageHandler(product = '', event = '', data = {}) {
    const { metaData = {}, city = '', checkinDate = '', checkoutDate = '', totalNights = '', rating = '', nationality = '',
        countryOfResidence = '', fsc: specialCategory = '', roomInfos = [], searchIds = [], name: hotel = '',
        suppliers = [], address = {}, uid = '', subRegionName = '', starRating = '', roomInfo = '', noOfNight = 0 ,userRating= "" } = data,
        [searchId = ''] = searchIds,
        { city: location = '' } = address,
        { userId } = metaData;

    let finalData = {
        Identity: userId, product: product, searchId: searchId
    }
    const { roomCount = 0, adultCount = 0, childCount = 0 } = getRoomInfo(roomInfos);

    switch (event) {
        case 'PageView':
            finalData = { ...finalData, location: city }
            break;
        case 'ModifySearch':
            finalData = { ...finalData, location: city, checkinDate, checkoutDate, totalNights, rating, nationality, countryOfResidence, specialCategory, roomCount, adultCount, childCount }
            break;
        case 'HotelFilter':
            finalData = { ...finalData, location, unicaId: uid, suppliers: suppliers.join() }
            break;
        case 'LocationFilter':
            finalData = { ...finalData, location: city }
            break;
        case 'Ratings':
            finalData = { ...finalData, location: city, rating }
            break;
        case 'SelectRoom':
            finalData = { ...finalData, location: location || city, unicaId: uid, suppliers: suppliers.join() }
            break;
        case 'subRegionName':
            finalData = { ...finalData, location: location || city, subRegionName }
            break;
        case 'AddToFavourites':
            finalData = { ...finalData, location: location || city, Rating: starRating, HotelNameSelected: hotel }
            break;
        case 'ViewFavourites':
            finalData = { ...finalData, location: location || city, checkinDate, checkoutDate, AdultCount: adultCount, ChildCount: childCount, RoomCount: roomCount }
            break;
        case 'FreeCancellationAvailable':
            finalData = { ...finalData, location: location || city, checkinDate, checkoutDate, adultCount, childCount, roomCount, totalNights: noOfNight }
            break;
        case 'click_Filter': 
        finalData = { ...finalData, location: city, userRating } 
        break;
        case "hover_reviewLink": 
        finalData = { ...finalData, location: city } 
        break;
        case "click_reviewLink": 
        finalData = { ...finalData, location: city } 
        break;
    }
    return finalData;
}

function getRoomInfo(roomInfo = []) {
    let roomCount = 0, adultCount = 0, childCount = 0;
    roomInfo.map(({ numberOfAdults, numberOfChild }) => {
        roomCount++;
        adultCount += parseInt(numberOfAdults);
        childCount += parseInt(numberOfChild);
    })
    return { roomCount, adultCount, childCount };
}

module.exports = { SearchPageHandler }